var Feed = /** @class */ (function () {
    /**
     * Constructor
     */
    function Feed(
    /**
     * Feed identifier
     */
    id, 
    /**
     * Feed text
     */
    text, 
    /**
     * Feed type
     */
    feedType, 
    /**
     * The user who send the feedback
     */
    user) {
        this.id = id;
        this.text = text;
        this.feedType = feedType;
        this.user = user;
    }
    return Feed;
}());
export { Feed };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/common/feed.ts
// module id = 614
// module chunks = 50